export const removeDiacritic = (text: string) => text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
